import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomMomentDateAdapter extends MomentDateAdapter {
  private readonly DATE_FORMAT_REGEX = '^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$';


  parse(value: any, parseFormat: string | string[]): moment.Moment | null {
    const regExp: RegExp = new RegExp(this.DATE_FORMAT_REGEX);
    if (!value || regExp.test(value)) {
      return super.parse(value, parseFormat);
    }
    return moment.invalid();
  }
}
